export default __webpack_public_path__ + "static/brecht-eberhard-1024x1024-1-a85ccc04d1dd198301cfe422bbd631e4.jpg";